export const physicalFormatsConstants = {
	GET_PHYSICAL_FORMATS_REQUEST: 'GET_PHYSICAL_FORMATS_REQUEST',
	GET_PHYSICAL_FORMATS_SUCCESS: 'GET_PHYSICAL_FORMATS_SUCCESS',
	GET_PHYSICAL_FORMATS_FAILURE: 'GET_PHYSICAL_FORMATS_FAILURE'    
}